import React from 'react';
import { motion } from 'framer-motion';

const TableSkeleton = () => {
    // Animation for shimmer effect
    const shimmer = {
        hidden: { x: '-100%' },
        visible: {
            x: '100%',
            transition: {
                repeat: Infinity,
                duration: 1.5,
                ease: 'linear'
            }
        }
    };

    // Create array for skeleton rows
    const rows = Array(10).fill(null);

    return (
        <div className="overflow-x-auto rounded-xl">
            <table className="w-full text-sm text-left rounded-xl">
                <thead className="text-xs uppercase bg-neutral-100 dark:bg-neutral-800 dark:text-neutral-200 rounded-xl">
                <tr>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                    <th className="p-4"></th>
                </tr>
                </thead>
                <tbody>
                {rows.map((_, index) => (
                    <tr key={index} className="border-t dark:border-neutral-700">
                        <td className="p-4">
                            <div className="relative w-24 h-4 bg-neutral-100 dark:bg-neutral-800 rounded overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative h-10 w-10 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative w-48 h-4 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative w-24 h-4 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative w-20 h-4 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative w-16 h-6 bg-neutral-200 dark:bg-neutral-800 rounded-full overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="relative w-16 h-6 bg-neutral-200 dark:bg-neutral-800 rounded-full overflow-hidden">
                                <motion.div
                                    className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                    variants={shimmer}
                                    initial="hidden"
                                    animate="visible"
                                />
                            </div>
                        </td>
                        <td className="p-4">
                            <div className="flex items-center gap-2">
                                <div className="relative w-8 h-8 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                    <motion.div
                                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                        variants={shimmer}
                                        initial="hidden"
                                        animate="visible"
                                    />
                                </div>
                                <div className="relative w-8 h-8 bg-neutral-200 dark:bg-neutral-800 rounded overflow-hidden">
                                    <motion.div
                                        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
                                        variants={shimmer}
                                        initial="hidden"
                                        animate="visible"
                                    />
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableSkeleton;
